const retryDelays = [5000, 10000, 15000, 20000, 20000, 20000];
const maxWait = 90000;

function canceled() { return new DOMException("Ожидание остановлено", "AbortError"); }

function wait(delay: number, signal: AbortSignal): Promise<void> {
    return new Promise((resolve, reject) => {
        if (signal.aborted) { reject(canceled()); return; }
        const abort = () => { window.clearTimeout(timer); reject(canceled()); };
        const timer = window.setTimeout(() => { signal.removeEventListener("abort", abort); resolve(); }, delay);
        signal.addEventListener("abort", abort, { once: true });
    });
}

/** Replay only a verified refusal before generation, never a failed or partial answer. */
export async function waitForAssistant<T>(send: () => Promise<T>, signal: AbortSignal, onWaiting: (waiting: boolean) => void): Promise<T> {
    let deadline: number | undefined;
    for (let attempt = 0; ; ++attempt) {
        if (signal.aborted) throw canceled();
        onWaiting(false);
        try { return await send(); }
        catch (error: any) {
            if (signal.aborted) throw canceled();
            if (error?.status !== 429 || error?.details?.code !== "assistant_busy") throw error;
            deadline ??= Date.now() + maxWait;
            const delay = retryDelays[attempt];
            if (delay === undefined || Date.now() + delay > deadline) throw error;
            onWaiting(true);
            await wait(delay, signal);
            // Background tabs may resume well after the retry window expires.
            if (Date.now() > deadline) throw error;
        }
    }
}
